import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BrowserRouter as Router} from 'react-router-dom';
import { ConfigProvider } from 'antd';
// import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


ReactDOM.render(
  <Router>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#C51020',
          colorLink: '#C51020',
          colorInfo: '#2E86AB',
          borderRadius: 8,
          fontFamily: "'Jost', sans-serif",
        },
      }}
    >
      <App />
    </ConfigProvider>
  </Router>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
